import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { ChangePasswordPage } from '../../../features/auth/change-password/ui/ChangePasswordPage';
import { IAccountChangePasswordPageData } from '../../../features/account/domain/pages/IAccountChangePasswordPageData';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IAccountChangePasswordPageData> =
	createGetStaticPropsWithPage(PassengersPageId.ChangePassword);

export default ChangePasswordPage;
